import './style.scss';

export function home_hero_block() {
    const block = document.querySelector('.home_hero_block');
    if (!block) return;

    const videoWrapper = block.querySelector('.video-wrapper');
    const video = videoWrapper?.querySelector('video[data-src]');
    if (!videoWrapper || !video) return;

    const desktopMedia = window.matchMedia('(min-width: 768px)');

    const loadResponsiveVideo = () => {
        const source = desktopMedia.matches
            ? video.dataset.src
            : video.dataset.mobileSrc;
        if (!source) return;

        if (video.dataset.activeSrc === source) return;

        videoWrapper.classList.remove('is-video-ready');
        video.dataset.activeSrc = source;
        video.src = source;
        video.addEventListener('canplay', () => {
            if (video.dataset.activeSrc === source) {
                videoWrapper.classList.add('is-video-ready');
            }
        }, {once: true});
        video.load();

        const playPromise = video.play();
        if (playPromise?.catch) {
            playPromise.catch(() => {});
        }
    };

    loadResponsiveVideo();
    desktopMedia.addEventListener('change', loadResponsiveVideo);
}
